if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"], input[name="language_code"]'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        button: this.querySelector('button'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.querySelectorAll('.disclosure__link').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() === 'ESCAPE') this.closeSelector();
      if (event.code.toUpperCase() === 'ARROWUP') { event.preventDefault(); this.focusPrev(); }
      if (event.code.toUpperCase() === 'ARROWDOWN') { event.preventDefault(); this.focusNext(); }
    }

    onFocusOut(event) {
      if (!this.contains(event.relatedTarget)) this.closeSelector();
    }

    focusPrev() {
      const links = Array.from(this.querySelectorAll('.disclosure__link'));
      const i = links.indexOf(document.activeElement);
      if (i > 0) links[i-1].focus();
    }

    focusNext() {
      const links = Array.from(this.querySelectorAll('.disclosure__link'));
      const i = links.indexOf(document.activeElement);
      if (i < links.length-1) links[i+1].focus();
    }

    openSelector(event) {
      event.preventDefault();
      if (this.elements.panel) {
        this.elements.panel.hidden = !this.elements.panel.hidden;
        this.elements.button.setAttribute('aria-expanded', this.elements.panel.hidden ? 'false' : 'true');
      }
    }

    closeSelector() {
      if (this.elements.panel) {
        this.elements.panel.hidden = true;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.button.focus();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const link = event.currentTarget;
      const locale = link.dataset.value || link.getAttribute('hreflang');
      if (locale) {
        const path = window.location.pathname;
        // 去掉已有语言前缀 /ru/ /ar/ 等
        const cleanPath = path.replace(/^\/(ru|ar|en|zh)\//, '/').replace(/\/$/, '') || '/';
        if (locale === 'en') {
          // 默认语言，直接跳根路径
          window.location.href = cleanPath === '/' ? '/' : cleanPath;
        } else {
          // 其他语言，加语言前缀
          window.location.href = '/' + locale + cleanPath;
        }
      } else {
        // fallback: form 提交
        const form = this.querySelector('form');
        if (this.elements.input && link.dataset.value) {
          this.elements.input.value = link.dataset.value;
          if (form) form.submit();
        }
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
